import { render, staticRenderFns } from "./createCoordination.modal.vue?vue&type=template&id=cb8c2d00&scoped=true&"
import script from "./createCoordination.modal.vue?vue&type=script&lang=js&"
export * from "./createCoordination.modal.vue?vue&type=script&lang=js&"
import style0 from "./createCoordination.modal.vue?vue&type=style&index=0&id=cb8c2d00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8c2d00",
  null
  
)

export default component.exports